import { SampleWeddingInfo } from "./SampleWeddingInfo";
import { WeddingInfo20260328 } from "./WeddingInfo20260328";
import { YounghunWeddingInfo } from "./YounghunWeddingInfo";

/* Common */

export interface CommonInfo {
  groomName: string;
  brideName: string;
  groomShortName: string;
  brideShortName: string;
  addressInfo: AddressInfo;
  weddingDateKR: string;
  weddingDate: string;
  groomAccountInfos: AccountInfo[];
  brideAccountInfos: AccountInfo[];
  accountInfos: AccountInfo[];
  parentBGM: string | null
  netflixBGM: string | null
  instagramBGM: string | null
  spotifyBGM: string | null
}

export interface AddressInfo {
  name: string;
  lat: number;
  lon: number;
  address: string;
  naverAddress: string;
}

export interface AccountInfo {
  name: string;
  familyName: string;
  bankName: string;
  bankImage: string;
  accountNumber: string;
  isGroom: boolean;
}

/* Common End */

/* Parent */

export interface ParentInfo {
  startPhrase: string;
  shortPhrase: string;
  mainImage: string;
  weddingMessage: string;
  groomFatherName: string;
  groomMotherName: string;
  groomFamilyTitle: string;
  brideFatherName: string;
  brideMotherName: string;
  brideFamilyTitle: string;
  photoGalleryPhrase: string;
  photoGalleryImages: string[];
  poetry: string;
  endImage: string;
}

/* Parent End */

/* Insta */

export interface InstaInfo {
  storyImages: string[];
  postInfos: InstaPostInfo[];
  gridInfo: InstaGridInfo;
}

export interface InstaPostInfo {
  profileImage: string;
  name: string;
  postImages: string[];
  title: string;
  caption: string;
}

export interface InstaGridInfo {
  profileImage: string;
  name: string;
  startDay: string;
  images: string[];
}

/* Insta End */

/* Spotify */

export interface SpotifyInfo {
  albumTitle: string;
  albums: SpotifyAlbumInfo[];
  lyricTitle: string;
  lyrics: SpotifyLyricInfo[];
  player: SpotifyPlayerInfo;
  list: SpotifyListInfo;
  artist: SpotifyArtistInfo;
}

export interface SpotifyAlbumInfo {
  mainImage: string;
  title: string;
  caption: string;
  topRightCaption: string;
}

export interface SpotifyLyricInfo {
  message: string;
  color: string;
  hightlightLines: number[];
}

export interface SpotifyPlayerInfo {
  sectionTitle: string;
  videoURL: string;
  title: string;
  caption: string;
}

export interface SpotifyListInfo {
  sectionTitle: string;
  images: string[];
  titles: string[];
  captions: string[];
}

export interface SpotifyArtistInfo {
  sectionTitle: string;
  images: string[];
  titles: string[];
  captions: string[];
}

/* Spotify End */

/* Netflix */

export interface NetflixInfo {
  posterInfo: NetflixPosterInfo;
  top10Info: NetflixTop10Info;
  newHotInfo: NetflixNewHotInfo;
  heartInfo: NetflixHeartInfo;
  accountInfo: AccountInfo[]
}

export interface NetflixPosterInfo {
  image: string;
  title: string;
  caption: string;
}

export interface NetflixTop10Info {
  sectionTitle: string;
  images: string[];
}

export interface NetflixNewHotInfo {
  videoURL: string;
  title: string;
  caption: string;
  message: string;
}

export interface NetflixHeartInfo {
  sectionTitle: string;
  images: string[];
  titles: string[];
  percents: number[];
}

/* Netflix End */

export interface WeddingInfoType {
  common: CommonInfo;
  parent: ParentInfo;
  instagram: InstaInfo;
  spotify: SpotifyInfo;
  netflix: NetflixInfo;
}

export enum WeddingId {
  Sample = "sample",
  Younghun = "love",
  // Nov092025 = "20251109" // expired
  Mar282026 = "20260328"
}

export const WeddingInfo = {
  getInfo: (id: string | undefined): WeddingInfoType => {
    if (id === WeddingId.Younghun) {
      return YounghunWeddingInfo;
    } else if (id === WeddingId.Mar282026) {
      return WeddingInfo20260328;
    } else {
      return SampleWeddingInfo
    }
  },
};
